module.exports = __webpack_public_path__ + "img/Angel12.27076635.jpg";